import { useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';

import { BottomButtonsContent, BottomButtonsWrapper } from './SelectFavouriteTeam.styled';

type FooterWidgetContainerProps = {
	isSubmittable: boolean;
	maxWidth: number;
	onSkip?: () => void;
	onSubmit: () => void;
};

export const FooterWidgetContainer = ({ isSubmittable, maxWidth, onSkip, onSubmit }: FooterWidgetContainerProps) => {
	const { $t } = useIntl();

	return (
		<BottomButtonsWrapper>
			<BottomButtonsContent $maxWidth={maxWidth}>
				{onSkip && (
					<Button
						fullWidth
						testID="selectFavouriteTeam-skip-button"
						text={$t('selectFavouriteTeam.actions.skip')}
						variant="outlined"
						onClick={onSkip}
					/>
				)}

				<Button
					disabled={!isSubmittable}
					fullWidth
					testID="selectFavouriteTeam-submit-button"
					text={$t('global.button.submit')}
					onClick={onSubmit}
				/>
			</BottomButtonsContent>
		</BottomButtonsWrapper>
	);
};
